import { writable } from 'svelte/store';

export const characterSettingsStore = writable(0);
